import { render, staticRenderFns } from "./jyj_jiuyetj.vue?vue&type=template&id=27176547&scoped=true"
import script from "./jyj_jiuyetj.vue?vue&type=script&lang=js"
export * from "./jyj_jiuyetj.vue?vue&type=script&lang=js"
import style0 from "./jyj_jiuyetj.vue?vue&type=style&index=0&id=27176547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27176547",
  null
  
)

export default component.exports